(() => {
  if (window.anydayEditableLP) { window.anydayEditableLP.refresh(); return; }
  const instances = new Map();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
const initReveals = container => {
  var root = container;
  if (!root || !('IntersectionObserver' in window) || !Element.prototype.animate || (window.Shopify && Shopify.designMode)) return;
  var motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches) return;
  var animations = new Map();
  var groups = Array.from(root.querySelectorAll('.five-reasons__hero-copy, .five-reasons__intro-inner, .glass-quote, .five-reasons__reason-head, .five-reasons__reason-body, .five-reasons__badges, .glass-feature-grid, .glass-faq > .page-width'));
  // Observe these pieces individually so stacked mobile content reveals on arrival.
  var independent = Array.from(root.querySelectorAll('.glass-gallery, .glass-buy-info > *, .glass-reviews header > *, .glass-reviews .glass-objections-heading, .glass-objections > article, .glass-junip'));
  groups = groups.concat(independent);
  groups.forEach(function (group) {
    var elements = independent.includes(group) ? [group] : Array.from(group.children).filter(function (element) { return !['STYLE', 'SCRIPT'].includes(element.tagName); });
    elements = elements.flatMap(function (element) {
      return element.matches('.five-reasons__copy, .five-reasons__system-copy, .five-reasons__badge-list') ? Array.from(element.children) : [element];
    });
    var sequence = elements.map(function (element, index) {
      var animation = element.animate(
        [{ opacity: 0, transform: 'translateY(28px)' }, { opacity: 1, transform: 'translateY(0)' }],
        { duration: 1400, delay: index * 130, easing: 'cubic-bezier(0.22, 0.61, 0.36, 1)', fill: 'both' }
      );
      animation.pause();
      animation.currentTime = 0;
      animation.onfinish = function () { animation.cancel(); };
      return animation;
    });
    animations.set(group, sequence);
  });
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (motion.matches) return;
      var sequence = animations.get(entry.target);
      if (sequence) sequence.forEach(function (animation) { animation.play(); });
    });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0.04 });
  groups.forEach(function (group) { observer.observe(group); });
  function stop() {
    observer.disconnect();
    animations.forEach(function (sequence) { sequence.forEach(function (animation) { animation.cancel(); }); });
    animations.clear();
  }
  function focused(event) {
    animations.forEach(function (sequence, group) {
      if (group.contains(event.target)) {
        observer.unobserve(group);
        sequence.forEach(function (animation) { animation.cancel(); });
      }
    });
  }
  function restored(event) { if (event.persisted) stop(); }
  root.addEventListener('focusin', focused);
  window.addEventListener('pageshow', restored);
  function changed() { if (motion.matches) stop(); }
  motion.addEventListener('change', changed);
  return () => { stop(); motion.removeEventListener('change', changed); root.removeEventListener('focusin', focused); window.removeEventListener('pageshow', restored); };
};
  function syncProduct() {
    const source = document.querySelector('[data-lp-product]');
    let data = {hasProduct:false, hasSavings:false,price:'',compare:'',savings:''};
    if (source) { try { data = JSON.parse(source.textContent); } catch (_) {} }
    document.querySelectorAll('[data-lp-copy]').forEach(element => {
      let markup = element.dataset.lpCopy;
      if (!data.hasSavings) {
        markup = markup.replace(/SAVE \{savings\} ON THE STARTER SET/gi, 'SHOP THE STARTER SET')
          .replace(/Get \{savings\} off the Starter Set/gi,'Get the Starter Set')
          .replace(/\{compare\} of dinner tools\./g,'Dinner tools.')
          .replace(/It’s a \{compare\} value for \{price\}\./g,'');
      }
      if (!data.hasProduct) markup = markup.replace(/ · \{price\}/g,'').replace(/Yours for \{price\}\./g,'Choose your set below.');
      const template = document.createElement('template');
      template.innerHTML = markup;
      const walker = document.createTreeWalker(template.content, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) walker.currentNode.textContent = walker.currentNode.textContent.replace(/\{(price|compare|savings)\}/g, (_,key) => data[key] || '');
      element.replaceChildren(template.content.cloneNode(true));
    });
    document.querySelectorAll('[data-lp-compare]').forEach(el => { el.hidden = !data.hasSavings; el.textContent = data.compare; });
    document.querySelectorAll('[data-lp-save-badge]').forEach(el => { el.hidden = !data.hasSavings; el.textContent = 'SAVE '+data.savings; });
    window.dispatchEvent(new Event('anyday:product-synced'));
  }
  function init(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const signal = controller.signal;
    const cleanups = [() => controller.abort()];
    const listen = (target,event,fn,options={}) => target?.addEventListener(event,fn,{...options,signal});
    const resize = (target,fn) => {
      if (!target) return;
      const observer = new ResizeObserver(fn); observer.observe(target); cleanups.push(() => observer.disconnect());
    };
    const stopReveals = initReveals(root);
    if (stopReveals) cleanups.push(stopReveals);
    const ticker = root.querySelector('.glass-ticker');
    if (ticker) {
      const group = ticker.querySelector('.glass-ticker-group');
      const update = () => { if (!root.isConnected) return; ticker.classList.remove('is-overflowing'); ticker.classList.toggle('is-overflowing',group.scrollWidth > ticker.clientWidth); };
      resize(ticker, update); listen(window,'anyday:product-synced',update); document.fonts.ready.then(update); update();
    }
    const track = root.querySelector('.glass-gallery-track');
    if (track) {
      const buttons = [...root.querySelectorAll('[data-slide]')];
      const thumbnails = root.querySelector('.glass-thumbnails');
      const count = root.querySelector('.glass-gallery-count');
      let active = 0, frame;
      const reveal = index => {
        const button = buttons[index]; if (!button) return;
        const viewport = thumbnails.getBoundingClientRect(), rect = button.getBoundingClientRect();
        const delta = rect.left < viewport.left ? rect.left-viewport.left : rect.right > viewport.right ? rect.right-viewport.right : 0;
        if (delta) thumbnails.scrollBy({left:delta,behavior:reduced.matches?'instant':'smooth'});
      };
      const update = () => {
        if (!buttons.length || !track.clientWidth) return;
        const index = Math.max(0,Math.min(buttons.length-1,Math.round(track.scrollLeft/track.clientWidth)));
        buttons.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));
        if (active !== index) { active=index; reveal(index); }
        count.textContent = `${index+1} / ${buttons.length} · swipe →`;
      };
      const go = index => track.scrollTo({left:Math.max(0,Math.min(buttons.length-1,index))*track.clientWidth,behavior:reduced.matches?'instant':'smooth'});
      buttons.forEach((button,i)=>listen(button,'click',()=>go(i)));
      listen(thumbnails,'focusin',e=>{const i=buttons.indexOf(e.target);if(i>=0)reveal(i);});
      listen(track,'scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);},{passive:true});
      listen(track,'keydown',e=>{
        if (!buttons.length || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();go(e.key==='Home'?0:e.key==='End'?buttons.length-1:active+(e.key==='ArrowRight'?1:-1));
      });
      resize(track,()=>{track.scrollTo({left:active*track.clientWidth,behavior:'instant'});update();});
      resize(thumbnails,()=>reveal(active));
      cleanups.push(()=>cancelAnimationFrame(frame));update();
    }
    const links = [...root.querySelectorAll('a.glass-checkout')];
    if (links.length) {
      const labels = links.map(link=>link.innerHTML);
      let pending=false,timeout;
      const reset = () => {
        clearTimeout(timeout);pending=false;root.classList.remove('is-checking-out');
        links.forEach((link,i)=>{link.innerHTML=labels[i];link.removeAttribute('aria-disabled');link.removeAttribute('aria-busy');link.blur();});
      };
      links.forEach(link=>listen(link,'click',event=>{
        if(pending){event.preventDefault();event.stopImmediatePropagation();return;}
        if(event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
        pending=true;root.classList.add('is-checking-out');
        links.forEach(button=>{button.textContent='PREPARING YOUR CHECKOUT...';button.setAttribute('aria-disabled','true');button.setAttribute('aria-busy','true');});
        timeout=setTimeout(reset,30000);
      },{capture:true}));
      listen(window,'pageshow',reset);cleanups.push(reset);
    }
    const sticky=root.querySelector('.glass-sticky');
    if(sticky){
      let frame;
      const update=()=>{
        const image=document.querySelector('[data-lp-section="reasons"] .five-reasons__reason-image') || document.querySelector('[data-lp-section="hero"]');
        const buy=root.querySelector('.glass-buy-info .glass-checkout, .glass-buy-info button');
        const rect=buy?.getBoundingClientRect();
        const visible=!!(image && rect && matchMedia('(max-width:767px)').matches && image.getBoundingClientRect().top<innerHeight && !(rect.top<innerHeight && rect.bottom>0));
        sticky.classList.toggle('is-visible',visible);sticky.inert=!visible;sticky.setAttribute('aria-hidden',String(!visible));
      };
      const schedule=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update);};
      listen(window,'scroll',schedule,{passive:true});listen(window,'resize',schedule);listen(window,'pageshow',schedule);resize(document.body,schedule);cleanups.push(()=>cancelAnimationFrame(frame));update();
    }
    listen(root,'shopify:block:select',event=>{const details=event.target.closest('details');if(details)details.open=true;});
    instances.set(root,()=>cleanups.forEach(fn=>fn()));
  }
  function refresh(){
    for(const [root,dispose] of instances){if(!root.isConnected){dispose();instances.delete(root);}}
    document.querySelectorAll('[data-lp-section]').forEach(init);syncProduct();
  }
  window.anydayEditableLP={refresh};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',refresh,{once:true});else refresh();
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:reorder',refresh);
  document.addEventListener('shopify:section:unload',event=>{
    event.target.querySelectorAll('[data-lp-section]').forEach(root=>{instances.get(root)?.();instances.delete(root);});
    setTimeout(refresh,0);
  });
})();
